<div class="page-title-overlap stylish-color-img posi">
  <div class="container d-lg-flex justify-content-between pt-3">
    <div class="order-lg-2 mb-3 mb-lg-0 pt-lg-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb-light flex-lg-nowrap justify-content-center justify-content-lg-start pb-2">
          <li class="breadcrumb-item"><a class="text-nowrap" routerLink="/home" ><i
                class="fa fa-home"></i>{{"pages.breadcrumb.home" | translate }}</a></li>
                <li class="breadcrumb-item text-nowrap active" aria-current="page">{{"pages.breadcrumb.individual" | translate }}</li>
                <li class="breadcrumb-item text-nowrap active" aria-current="page" >{{"pages.breadcrumb.recharge" | translate }}</li>
        </ol>
      </nav>
    </div>
    <div class="order-lg-1 pr-lg-4 text-center text-lg-left">
      <h1 class="h3 text-light mb-0"></h1>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <h1 class="text-center mb-2 pt-2" style="color: #033B55; font-size: 38px; font-weight: bold;">
        {{"pages.rechargeCard.rechargeCardTitle" | translate }}
      </h1>
      <p class="text-center mb-2" style="color: white;">
        {{"pages.rechargeCard.rechargeCardUtility" | translate }}
      </p>
    </div>
  </div>
</div>


<div style="background-color: #f8f9fb; padding-top: 40px;">
  <div class="container">


    <div class="row text-center pt-3">
      <div class="col-sm-4">
        <p>
          <span class="text-white bg-success rounded-circle h1" style="font-size: 3rem; font-weight: bold; padding: 20px; padding-top: 3px; padding-bottom: 3px;">1</span>
        </p>
        <p class="pt5">
          {{"pages.rechargeCard.cardRechargeProcess1" | translate }}
        </p>
      </div>
      <div class="col-sm-4">
        <p>
          <span class="text-white bg-success rounded-circle h1" style="font-size: 3rem; font-weight: bold; padding: 20px; padding-top: 3px; padding-bottom: 3px;">2</span>
        </p>
        <p class="pt5" >
          {{"pages.rechargeCard.cardRechargeProcess2" | translate }}
        </p>
      </div>
      <div class="col-sm-4">
        <p>
          <span class="text-white bg-success rounded-circle h1" style="font-size: 3rem; font-weight: bold; padding: 20px; padding-top: 3px; padding-bottom: 3px;">3</span>
        </p>
        <p class=" pt5">
          {{"pages.rechargeCard.cardRechargeProcess3" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>

<section class="backcolor" style="background-color: #f8f9fb;">
  <div class="container">

    <div class="row featurette pt-5" *ngIf="!isInsured">
      <div class="col-md-7 order-md-2">
        <h2 class="featurette-heading pt-4" style="font-size: 1.8em;">{{"pages.rechargeCard.enterCardNumber" | translate }}</h2>
        <form #f="ngForm" (ngSubmit)="searchById(f)">

          <div class="form-group">
            <input style="width: 300px;" class="form-control" type="text" ngModel placeholder= "{{'pages.rechargeCard.cardNumberPlaceholder' | translate }}"
              name="numero" minlength="8" maxlength="12" required>
            <span style="color: red;" *ngIf="message">{{message}}</span>

          </div>



          <div class="mt-2">

            <button [disabled]="f.invalid" type="submit" class="btn ml-2" style="background-color: #033b55; color:white">{{"pages.rechargeCard.searchButton" | translate }}</button>
          </div>
        </form>


      </div>
      <div class="col-md-5 order-md-1 mb-5">
        <img src="../../../../assets/img/card-number.png" alt="modele de carte" width="400" height="200">
      </div>
    </div>
    <div class="row featurette pt-5" *ngIf="isInsured">
      <div class="col-md-7 order-md-2" *ngIf="!showPaymentMode">
        <h2 class="featurette-heading">{{"pages.rechargeCard.cardRechargeProcess2" | translate }}</h2>
        <form #amountForm="ngForm" (ngSubmit)="setAmount(amountForm)">

          <div class="form-group">
            <input style="width: 300px;" class="form-control" type="number" ngModel placeholder="Montant de la recharge"
              name="amount" required>
            <span style="color: red;" *ngIf="message">{{message}}</span>

          </div>



          <div class="mt-2">
            <button [disabled]="amountForm.invalid" type="submit" class="btn btn-success ml-2"> {{"pages.rechargeCard.submit" | translate }} </button>
          </div>
        </form>


      </div>
      <div class="col-md-7 order-md-2 mb-1" *ngIf="showPaymentMode">
        <!-- <h2 class="featurette-heading">Mode de payement</h2> -->
        <ng-template #customLoadingTemplate>
          <div class="custom-class">

            <h3> {{"pages.rechargeCard.paymentInProcess" | translate }} </h3>

          </div>
        </ng-template>

        <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }" [template]="customLoadingTemplate">
        </ngx-loading>
        <div class="mt-2 text-center">

          <p class="" > {{"pages.rechargeCard.slectPaymentMode" | translate }} </p>


          <button type="button" (click)="payement()" class="mr-3"
            style="background-image: url(../../../../assets/img/orange.png) !important;background-size: cover; width: 98px; height: 75px;"></button>

          <button type="button" (click)="payementVisa()" class="mr-3"
            style="background-image: url(../../../../assets/img/card-visa.png) !important;background-size: cover; width: 98px; height: 75px;"></button>

        </div>

      </div>
      <div class="col-md-5 order-md-1 mb-5">
        <h2 class="featurette-heading col-sm-10 offset-sm-1 text-center mt-2"> {{"pages.rechargeCard.personalInformation" | translate }} </h2>
        <label class="col-sm-5 offset-sm-1">N°: </label>
        <span class="col-sm-5">{{ insured?.numero }} </span>

        <label class="col-sm-5 offset-sm-1">{{"pages.rechargeCard.cardOwnerLname" | translate }} </label>
        <span class="col-sm-5">{{ insured?.lastname }} </span>

        <label class="col-sm-5 offset-sm-1">{{"pages.rechargeCard.cardOwnerFname" | translate }} </label>
        <span class="col-sm-5">{{ insured?.firstname }} </span>
        <label class="col-sm-5 offset-sm-1"> {{"pages.rechargeCard.currentSold" | translate }} </label>
        <span class="col-sm-5">{{ insured?.card?.thebalance }}GNF </span>
        <div *ngIf="showPaymentMode">
          <label class="col-sm-5 offset-sm-1">{{"pages.rechargeCard.amount" | translate }} </label>
          <span class="col-sm-5">{{ amount }}GNF </span>
        </div>
      </div>
    </div>
  </div>


</section>

<div style="background-color: #f8f9fb;">
  <div class="container">
    <h2 class="size-33" style="font-size: 38px; font-weight: bold;  color: #033b55;">
      {{"pages.rechargeCard.uselessInformations" | translate }}
    </h2>

    <div class="row">
      <div class="col-12">
        <p class="pt1">
          <strong>1.</strong>
           <span class="text-center">
            {{"pages.rechargeCard.useless1" | translate }}
            </span>  <br>

            <strong>2.</strong>
           <span class="text-center">
            {{"pages.rechargeCard.useless2" | translate }}
            </span><br>

          <strong>3.</strong>
           <span class="text-center">
            {{"pages.rechargeCard.useless3" | translate }}
            </span><br>

            <strong>4.</strong>
           <span class="text-center">
            {{"pages.rechargeCard.useless4" | translate }}
            </span><br>

            <strong>5.</strong>
           <span class="text-center">
            {{"pages.rechargeCard.useless5" | translate }} <a routerLink="/our-partners">{{"pages.rechargeCard.here" | translate }}</a> 
            </span><br>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- type="ball-scale-multiple" -->


